<template>
  <div class="custom-select" @click.outside="closeOptions">
    <div class="selected" @click="toggleOptions">
      <span v-html="selectedOption ? selectedOption.name : 'Selecione...'"></span>
    </div>

    <div class="options" v-show="isOpen">
      <div
        class="option"
        v-for="(option, index) in options"
        :key="index"
        @click="selectOption(option)"
      >
        <span>{{ option.name }}</span>
        <span class="badge">{{ option.time }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomPriorityInput",
  props: {
    options: {
      type: Array,
      required: true, // Exemplo: [{ name: 'Option 1', value: 'opt1', badge: 3 }]
    },
    value: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isOpen: false,
      selectedOption: this.value,
    };
  },
  watch: {
    value(newVal) {
      this.selectedOption = newVal;
    },
  },
  methods: {
    toggleOptions() {
      this.isOpen = !this.isOpen;
    },
    closeOptions() {
      this.isOpen = false;
    },
    selectOption(option) {
      this.selectedOption = option;
      this.isOpen = false;
      this.$emit("input", option);
    },
  },
  directives: {
    outside: {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
          if (!(el === event.target || el.contains(event.target))) {
            binding.value(event);
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      },
    },
  },
};
</script>

<style scoped>
.custom-select {
  position: relative;
  width: 200px;
  font-family: sans-serif;
}

.selected {
  border: 1px solid #ccc;
  padding: 10px;
  cursor: pointer;
  background: white;
}

.options {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  border: 1px solid #ccc;
  background: white;
  z-index: 10;
}

.option {
  padding: 10px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}

.option:hover {
  background-color: #f0f0f0;
}

.badge {
  background-color: #007bff;
  color: white;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
}
</style>
